import React from 'react'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import arrayMove from 'array-move'
import { isEqual as _isEqual } from 'lodash'

import 'assets/sass/Dashboard/right-side-menu.scss'


class StockFavorite extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			// toggle visibility
			visible: false,

			// edit name
			is_editing: false,
			name: null,

			// sort
			is_sorting: false,

			// delete
			is_enabled: true,
			is_deleting_all: false,

			// add tab
			is_adding: false,
		};
	}

	/*
	 toggle:
	 1. visibility
	 */
	toggleHandler = () => this.setState((state) => ({ visible: !state.visible }))

	// 2. tab
	switchHandler = (idx) => this.props.onFavGroupSwitch(idx)

	/*
	 edit name:
	 1. toggle editability / submit
	 */
	editHandler = () => {
		const name = this.state.name;

		if (name && name.length > 0) {// edited
			const { current_group, onFavGroupNameEdit } = this.props;

			onFavGroupNameEdit({ group_id: current_group + 1, group_name: name });
		}

		this.setState((state) => ({ is_editing: !state.is_editing }));
	}

	// 2. on change
	changeHandler = (e) => this.setState({ name: e.target.value })

	submitHandler = (e) => {
		e.preventDefault();

		this.editHandler();
	}

	// sort
	sortEndHandler = ({ oldIndex, newIndex }) => {
		const { current_group, favs, onFavGroupDataTempSort } = this.props;

		let stocksSorted = favs[current_group].stocks;
		stocksSorted = arrayMove(stocksSorted, oldIndex, newIndex);

		onFavGroupDataTempSort({ current_group: current_group, temp: stocksSorted });
	}

	sortHandler = () => {
		const { current_group, favs, onFavGroupDataSort } = this.props;
		const stocksSorted = favs[current_group].stocks.map((item) => (item.id));

		this.setState(
			{ is_sorting: false },
			() =>	onFavGroupDataSort({ sorted_stocks: stocksSorted })
		);
	}

	/*
	 delete:
	 1. one by one
	 */
	removeHandler = (e) => {
		const { current_group, onFavGroupStockDelete } = this.props;
		const stockcode = e.currentTarget.dataset.stockcode;

		this.setState(
			{ is_enabled: false },
			() => {
				onFavGroupStockDelete({
					group_id: current_group + 1,
					stock_code: stockcode,
				});
			}
		);
	}

	// 2. all at once
	onModalOpen = () => this.props.onModalToggle('delete-all-fav-stock', true)

	// add tab
	addHandler = (e) => {
		this.setState((state) => ({ is_adding: !state.is_adding }));
		this.props.onFavGroupAdd();
	}

	// redirect
	redirectHandler = (e) => {
		const { stockcode, stockname } = e.currentTarget.dataset;

		this.props.onStockSet({ stock_code: stockcode, stock_name: stockname });
		this.setState({ visible: false });
	}

	FavTab = (item, idx) => (
		<div
			className={`my-fav-tab right-side-menu-tab tab-${idx}
					${(this.props.current_group === idx) ? 'active' : ''} bg-grey`}
			onClick={() => this.state.is_sorting ? {} : this.switchHandler(idx)}
			key={idx}
		>
			{idx + 1}
		</div>
	)

	FavItem = ({ item, index }) => {
		const { is_sorting, is_enabled } = this.state;

		return (
			<li key={item.sort - 1}>
				{is_sorting && (
					<span className='mover margin-right-5 cursor-move'>
						<i className='txt-medium elegant elegant-eleganticons-64'/>
					</span>
				)}

				<div
					className={`stock d-inline-block margin-right-5
							${is_sorting ? '' : 'cursor-pointer'}`}
					data-stockcode={item.stock_code}
					data-stockname={item.stock_name}
					onClick={is_sorting ? () => {} : this.redirectHandler}
				>
					<span className='stock-name margin-right-5 txt-normal'>
						{item.stock_name}
					</span>

					<span className='stock-code'>{item.stock_code}</span>
				</div>

				{!is_sorting && (
					<span
						className='remover margin-right-5 pull-right cursor-pointer'
						data-stockcode={item.stock_code}
						onClick={is_enabled ? this.removeHandler : null}
					>
						<i className='txt-medium elegant elegant-eleganticons-44'/>
					</span>
				)}

				{!is_sorting && (
					<span
						className='redirector margin-right-5 pull-right cursor-pointer'
						data-stockcode={item.stock_code}
						data-stockname={item.stock_name}
						onClick={this.redirectHandler}
					>
						<i className='txt-medium elegant elegant-eleganticons-20'/>
					</span>
				)}
			</li>
		);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			authenticated,
			favs,
			is_reload_needed,
			onFavGroupDataLoad,
			onModalToggle,
		} = this.props;

		if (prevProps.is_reload_needed !== is_reload_needed) {
			if (authenticated) {
				if (is_reload_needed) {
					onFavGroupDataLoad();
				} else {
					this.setState((state) => ({ is_adding: false }));
				}
			}
		}

		if (!_isEqual(prevProps.favs, favs)) {
			onModalToggle('delete-all-fav-stock');

			this.setState({ is_enabled: true });
		}
	}

	componentDidMount() {
		const { authenticated, onFavGroupDataLoad } = this.props;

		if (authenticated) {
			onFavGroupDataLoad();
		}
	}

	render() {
		const {
			visible,
			is_editing,
			is_sorting,
			is_deleting_all,
			is_adding,
		} = this.state;
		const { current_group, favs } = this.props;
		const FavList = SortableContainer(({ children }) => (
			<ul className='text-left'>{children}</ul>
		));
		const FavComponent = SortableElement(this.FavItem);
		const SortItem = (item, idx) => (
			<FavComponent index={idx} item={item} key={item.id} />
		);

		let component = null;

		if (favs.length > 0) {
			const count = favs.length;
			const list = favs[current_group].stocks;
			const nameComponent = is_editing
				?
				<form
					className='my-fav-name ua-form d-inline-block'
					name='my-fav-name-form'
					onSubmit={this.submitHandler}
				>
					<section className='inputs'>
						<input
							type='text'
							name='name'
							className='ua-input'
							placeholder='請輸入名稱'
							onChange = {this.changeHandler}
						/>
					</section>
				</form>
				:
				<h2 className='d-inline-block txt-normal'>
					{favs[current_group].group_name.length > 0 ? favs[current_group].group_name : `我的最愛 ${current_group + 1}`}
				</h2>;
			const btnEdit = !is_editing
				?
				<i
					className='cursor-pointer fa fa-pen'
					onClick={this.editHandler}
				/>
				:
				<strong
					className='margin-left-5 cursor-pointer'
					onClick={this.editHandler}
				>
					確定
				</strong>;
			const btnSort = !is_sorting
				?
				<i
					className='margin-top-13 cursor-pointer pull-right fas fa-sort'
					onClick={() => { this.setState({ is_sorting: true }) }}
				/>
				:
				<strong
					className='margin-top-10 cursor-pointer pull-right'
					onClick={this.sortHandler}
				>
					確定
				</strong>;
			const btnDelete = (
				<strong
					className='margin-top-10 cursor-pointer pull-right'
					onClick={this.onModalOpen}
				>
					刪除全部
				</strong>
			);

			component = (
				<div
					className={`my-fav-container right-side-menu ${visible ? 'show' : ''}`}
					title='我的最愛'
				>
					{/* TOGGLER */}
					<div
						className={`my-fav-tab right-side-menu-tab toggler bg-${visible
								? 'white' : 'orange'}`}
						onClick={this.toggleHandler}
					>
						{visible && <i className='txt-orange elegant elegant-eleganticons-172'/>}

						{!visible && (
							<div className='img-circle bg-white'>
								<h1 className='margin-top-0 txt-orange txt-normal'>
									{current_group + 1}
								</h1>
							</div>
						)}
					</div>

					{/* TABS */}
					{visible && favs.map(this.FavTab)}

					{/* ADD TAB */}
					{(visible && count < 12) && (
						<div
							className={`my-fav-tab right-side-menu-tab add-tab tab-${count}
									${is_adding ? 'active' : ''} bg-grey`}
							onClick={this.addHandler}
						>
							<i className='elegant-eleganticons-43'/>
						</div>
					)}

					{/* CONTENT */}
					<div className='my-fav-content right-side-menu-content bg-white'>
						{nameComponent}

						{!(is_editing || is_deleting_all) && btnSort}

						{(!(is_editing || is_sorting) && list.length > 0) && btnDelete}

						{!(is_sorting || is_deleting_all) && btnEdit}

						{is_sorting
							?
							<FavList
								helperClass='dragging-helper dragging-helper-my-fav'
								axis='y'
								lockAxis='y'
								distance={2}
								onSortEnd={this.sortEndHandler}
							>
				        {list.map(SortItem)}
				      </FavList>
							:
							<ul className='text-left'>
								{list.map((item, idx) => this.FavItem({ item }))}
							</ul>}
					</div>
				</div>
			);
		}

		return component;
	}
}


export { StockFavorite }
